import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

// Set once the first Portal has mounted on the client: from then on the app is hydrated and a
// portal can render in the same commit as its parent (so overlays can be measured immediately).
let hydrated = false;

/**
 * Renders overlays (Tooltip, Menu, Dialog, Sheet) at the end of <body>, so no ancestor's overflow,
 * transform or stacking context can clip them. Renders nothing on the server and, before hydration,
 * waits one effect so server and client markup match.
 */
export function Portal({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(hydrated);
  useEffect(() => {
    hydrated = true;
    setMounted(true);
  }, []);
  return mounted && typeof document !== 'undefined' ? createPortal(children, document.body) : null;
}
